<template>
  <v-row align="center" justify="center">
    <v-col md="6">
      <v-card>
        <v-card-title>
          Create user
        </v-card-title>
        <v-card-text>
          <validation-observer ref="validationObserver" slim>
            <user-form :user="user" :validations="validationRules"></user-form>
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="
                $router.push({ name: $routes.admin.user.indexRoute.name })
              "
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="createUser">
              Create
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { createUser } from "../../../../api/user.api.js";
import UserForm from "../../../components/user/UserForm.vue";
import { ValidationObserver } from "vee-validate";
import Validatable from "../../../mixins/Validatable.js";

export default {
  name: "UserCreate",
  components: {
    UserForm,
    ValidationObserver
  },
  mixins: [Validatable],
  data() {
    return {
      user: {
        username: null,
        password: null,
        passwordConfirmation: null,
        active: false
      }
    };
  },
  computed: {
    validationRules() {
      return {
        username: "required",
        password: "required",
        passwordConfirmation: "required|confirmed:password"
      };
    }
  },
  methods: {
    async createUser() {
      const { validationObserver } = this.$refs,
        isValid = await validationObserver.validate();

      if (isValid) {
        createUser(this.user)
          .then(() => {
            this.$router.push({
              name: this.$routes.admin.user.indexRoute.name
            });
          })
          .catch(error => this.handleErrorResponse(validationObserver, error));
      }
    }
  }
};
</script>
